projectFunctions.singleProductFunctions = projectFunctions.singleProductFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.singleProductFunctions.init = function() {
    this.scrollToSection();
    this.updateProductContentOnVariationSelection();
    this.radioButtonsBehaviour();
    this.triggerRadioButtons();
};
// Scroll to section on tab click
projectFunctions.singleProductFunctions.scrollToSection = function () {
    const tab = jQuery(".tab");
  
    if (!tab) {
      return
    }
  
    // Scroll to section & add active class on tab click
    jQuery(".tab").on('click', function () {
      const currentTab = jQuery(this);
      const adminBar = jQuery('.admin-bar');
      const goTo = jQuery(`${currentTab.data('go')}`);
      const goToTop = adminBar ? goTo.offset().top - 238 : goTo.offset().top - 186;
  
      tab.removeClass('active')
  
      currentTab.addClass('active');
  
      jQuery('html, body').animate({
        scrollTop: goToTop
      }, 500);
    });
  
    // When Tab content is 50% in viewport add active class
    const tabContent = jQuery('.tab-content');
    const viewportHeight = jQuery(window).height();
  
    jQuery(window).on('scroll', function () {
      var scrollTop = jQuery(window).scrollTop();
  
      tabContent.each(function () {
        const offsetTop = jQuery(this).offset().top;
        const offsetBottom = offsetTop + jQuery(this).height();
        var activeSection = scrollTop + viewportHeight * 0.7;
  
        if (activeSection >= jQuery(this).offset().top && activeSection <= offsetBottom) {
          const currentSectionId = jQuery(this).attr('id');
  
          tab.removeClass('active');
  
          jQuery(`[data-go="#${currentSectionId}"]`).addClass('active')
        }
      })
  
    });

}

//update product content when a variation is selected
projectFunctions.singleProductFunctions.updateProductContentOnVariationSelection = function (){
    // Get woocommerce variation form
  const form = jQuery('form.variations_form');

  if(!form || !form.length) return;

  // Capture the original HTML of the first dropdown to preserve all options
  const firstDropdown = jQuery('form.variations_form select').first();
  const firstDropdownOriginalOptions = firstDropdown.html();

  // Store main product (default) values.
  // We use first() because we have mobile and desktop .product-sku element with same value
  const defaultSku = jQuery('.product-sku').first().text();
  const defaultHmiNumber = jQuery('.hmi-number').first().text();
  const defaultProductDetails = jQuery('.product-details-container').html();
  const defaultProductAccessories = jQuery('#product-accessories').html();
  const defaultProductSpecifications = jQuery('#product-specifications').html();
  const defaultProductMountingInstructions = jQuery('#product-mounting-instructions').html();
  const defaultDownloads = document.querySelector('.downloads-filters-container');
  const defaultDownloadsId = defaultDownloads ? defaultDownloads.dataset.downloads : "";
  const defaultProductDownloadDatasheet = jQuery('.download-datasheet-container').html();

  // Make sure first dropdown always display all options
  function keepFirstDropDownOptions() {
    // Restore the original options in the first dropdown to ensure all options are displayed
    const selectedValue = firstDropdown.val(); // Get the currently selected value

    firstDropdown.html(firstDropdownOriginalOptions); // Restore full options
    firstDropdown.val(selectedValue); // Set the previously selected value as selected
  }

  form.on('show_variation', function (event, variation) {

    // To make sure the first dropdown always display all the options
    keepFirstDropDownOptions();

    // Check if the variation has default values
    var sku = variation.sku ? variation.sku : defaultSku;
    var hmiNumber = variation.product_hmi_number ? variation.product_hmi_number : defaultHmiNumber;
    var productDetails = variation.product_details ? variation.product_details : defaultProductDetails;
    var productAccessories = variation.product_accessories ? variation.product_accessories : defaultProductAccessories;
    var productSpecifications = variation.product_specifications ? variation.product_specifications : defaultProductSpecifications;
    var productMountinInstructions = variation.product_mounting_instructions ? variation.product_mounting_instructions : defaultProductMountingInstructions;
    var downloadsId = variation.product_downloads_id ? variation.product_downloads_id : defaultDownloadsId;
    var productDownloadDatasheet = variation.product_download_datasheet ? variation.product_download_datasheet : defaultProductDownloadDatasheet;

    // Update the SKU element
    jQuery('.product-sku').text(sku);

    // Update custom product content
    jQuery('.hmi-number').text(hmiNumber);
    jQuery('.product-details-container').html(productDetails);
    jQuery('#product-accessories').html(productAccessories);
    jQuery('#product-specifications').html(productSpecifications);
    jQuery('#product-mounting-instructions').html(productMountinInstructions);
    jQuery('.download-datasheet-container').html(productDownloadDatasheet);
    
    // Update product downloads in downloads filter
    //projectFunctions.downloadsLagFilterFunctions.filterDownloads(downloadsId);

    // Initialize Accessories slider
    initializeAccessoriesSlider();
  });

  // Reset content if no variation is selected
  form.on('hide_variation', function () {
    // To make sure the first dropdown always display all the options
    keepFirstDropDownOptions();

    // Reset content
    jQuery('.product-sku').text(defaultSku);
    jQuery('.hmi-number').text(defaultHmiNumber);
    jQuery('.product-details-container').html(defaultProductDetails);
    jQuery('#product-accessories').html(defaultProductAccessories);
    jQuery('#product-specifications').html(defaultProductSpecifications);
    jQuery('#product-mounting-instructions').html(defaultProductMountingInstructions);
    jQuery('.download-datasheet-container').html(defaultProductDownloadDatasheet);

    // Update product downloads in downloads filter
    projectFunctions.downloadsLagFilterFunctions.filterDownloads(defaultDownloadsId);

    // Initialize Accessories slider
    initializeAccessoriesSlider();
  });

  // Function to initialize Accessories slider
  function initializeAccessoriesSlider() {
    const accessoriesSlider = jQuery('.accessories-slider');

    if (!accessoriesSlider) {
      return;
    }

    const slideCount = accessoriesSlider.find('.accesory-container').length; // Count slides

    if (slideCount > 4) {

      if (accessoriesSlider.hasClass('slick-initialized')) {
        console.log('initialized');
        accessoriesSlider.slick('unslick'); // Destroy slick if already initialized
      }

      accessoriesSlider.slick({
        infinite: true, // Only infinite if slides are more than `slidesToShow`,
        dots: false,
        speed: 500,
        autoplay: false,
        slidesToShow: Math.min(slideCount, 4), // Use the smaller value
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        variableWidth: false,
        draggable: true, // Ensure dragging is enabled
        // appendArrows: jQuery('.carousel-buttons-container'),
        prevArrow: '<button class="slick_btn btn_prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#000"/></svg></button>',
        nextArrow: '<button class="slick_btn btn_next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#000"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: Math.min(slideCount, 2), // Adjust for mobile
              slidesToScroll: 1
            }
          },
        ]
      });
    }
  }
}

// Radio buttons behaviour
projectFunctions.singleProductFunctions.radioButtonsBehaviour = function (){
    const variationForm = jQuery('form.variations_form');
  let previousOptions = {};

  // Get prvious select options
  function getPreviousOptions(changedIndex) {
    variationForm.find('select').each(function (index) {
      const name = jQuery(this).attr('name');

      if (index < changedIndex) {
        // Store the current HTML of selects that come BEFORE the changed one
        previousOptions[name] = jQuery(this).html();
      }
    });
  };

  //Function to reset only the attributes following the changed one
  function resetFollowingAttributes(startIndex) {
    jQuery('form.variations_form select').each(function (index) {
      if (index > startIndex) {
        // Reset dropdown to "Choose an option" value
        jQuery(this).prop('selectedIndex', 0).trigger('change');
      }
    });
  }

  function updateRadioButtons() {
    variationForm.find('select.hidden').each(function (index) {
      var select = jQuery(this);
      var attributeName = select.attr('name');
      var attributeValue = select.val();
      var options = select.find('option');
      var variationRadios = select.siblings(".variation-radios");
      var variationRadioHtml = "";

      if (!variationRadios) {
        return;
      }

      jQuery.each(options, function () {
        var optionValue = jQuery(this).val();
        var optionText = jQuery(this).text();
        var isChecked = attributeValue === optionValue ? 'checked' : '';

        // If option value is empty (choose an option case) continue loop
        if (!optionValue || optionValue === "") {
          return true;
        }

        variationRadioHtml += `<label for="${attributeName}-${optionValue}">`;
        variationRadioHtml += `<input type="radio" id="${attributeName}-${optionValue}" name="${attributeName}" value="${optionValue}" ${isChecked}>`
        variationRadioHtml += optionText;
        variationRadioHtml += "</label>";
      });

      variationRadios.html(variationRadioHtml);
    });
  }

  // Listen for changes on each attribute dropdown
  variationForm.find('select').change(function () {
    // Get the index of the changed dropdown
    const changedIndex = jQuery('form.variations_form select').index(this);

    // Reset only the dropdowns following the changed one
    resetFollowingAttributes(changedIndex);

    // Keep before change select options
    getPreviousOptions(changedIndex);

    // Update radio buttons with available options
    updateRadioButtons();
  });

  // After WooCommerce filters variations...
  variationForm.on('woocommerce_variation_has_changed', function () {
    // Restore previous selects
    for (const name in previousOptions) {
      const select = variationForm.find(`select[name="${name}"]`);

      if (select.length) {
        const currentVal = select.val();
        select.html(previousOptions[name]); // Restore options
        select.val(currentVal); // Re-apply current value if it still exists
      }
    }

    // Clear after restoring
    previousOptions = {};
  });
}

// Trigger radio buttons
projectFunctions.singleProductFunctions.triggerRadioButtons = function (){
    // on radio button change(click)
  jQuery(document).on('change', '.variation-radios input', function () {
    // for each checked radio button we reflect the same changes to select dropdowns
    const radio = jQuery(this)
    const radioName = radio.attr('name')
    const radioValue = radio.attr('value')
    jQuery('select[name="' + radioName + '"]').val(radioValue).trigger('change');
  });
}
